export const SUPPORT_FORM_EN_HREF = 'https://support.zehitomo.com/hc/en-us/requests/new';
export const SUPPORT_FORM_JA_HREF = 'https://support.zehitomo.com/hc/ja/requests/new';
